var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-parent", attrs: { id: "dialogParent" } },
    [
      _c("div", {
        staticClass: "vo-scrim",
        class: { active: _vm.dialogComponent, disabled: _vm.lockout.on },
        on: {
          click: function($event) {
            _vm.routeRemoveQueries(["dialog", "dialogAction", "dialogItem"])
          }
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "grow" } }, [
        !!_vm.dialogComponent
          ? _c("div", { staticClass: "center-parent" }, [
              _c(
                "div",
                { staticClass: "dialog-wrapper" },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-header" },
                    [
                      _c("div", { staticClass: "header-title" }, [
                        _vm._v(_vm._s(_vm.title))
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: {
                            disabled: _vm.lockout.on,
                            small: "",
                            fab: "",
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.routeRemoveQueries([
                                "dialog",
                                "dialogAction",
                                "dialogItem"
                              ])
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { medium: "" } }, [
                            _vm._v("mdi-close")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("vo-" + _vm.dialogComponent, {
                    ref: "dialogCmp",
                    tag: "component",
                    staticClass: "component",
                    attrs: { lockout: _vm.lockout },
                    on: { title: _vm.setTitle }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a401742", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a401742","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DialogParent.vue
// module id = 467
// module chunks = 4